import React from 'react';
import type { InternalTrackingCode, ProratedRentResult, TrackingCode } from './types';
// Constellation
import { FONT_TYPES, Spacer, Text } from '@zillow/constellation';

// Misc / Utils
import * as S from './styles';

interface ResultsProps {
  proratedRent: ProratedRentResult;
  reset: () => void;
  itc: InternalTrackingCode;
  t: TrackingCode;
}

const ZRM_URL = 'zillow.com/rental-manager';

function displayCurrency(number: number): string {
  return '$' + parseFloat(number.toFixed(2)).toLocaleString();
}

const Results: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<ResultsProps>>> = (
  props: ResultsProps,
) => {
  const { itc, proratedRent, reset, t } = props;
  const zrmUrlWithTracking = `//${ZRM_URL}?itc=${itc}&t=${t}`;
  return (
    <S.CenterSpacer marginTop="lg">
      <Spacer marginBottom="xl">
        <Text as="p" fontType={FONT_TYPES.h6} marginBottom="xs">
          Prorated rent for the month of {proratedRent.month}
        </Text>
        <Text as="p" fontType={FONT_TYPES.h2} marginBottom="xs">
          {displayCurrency(proratedRent.days * proratedRent.dailyRent)}
        </Text>
        <Text as="p" fontType={FONT_TYPES.body} marginBottom="xs">
          <strong>{proratedRent.days}</strong> days * <strong>{displayCurrency(proratedRent.dailyRent)}</strong> per day
        </Text>
      </Spacer>
      <Spacer marginBottom="lg">
        <S.FixedWidthButton buttonType="primary" fluid onClick={reset} width={232}>
          Reset
        </S.FixedWidthButton>
      </Spacer>
      <S.SizeTwentyText as="p" marginBottom="xs">
        Want to streamline managing your properties?
      </S.SizeTwentyText>
      <S.SizeTwentyTextButton as="a" href={zrmUrlWithTracking}>
        Explore Zillow Rental Manager
      </S.SizeTwentyTextButton>
    </S.CenterSpacer>
  );
};

export default Results;
